export default __webpack_public_path__ + "static/media/sushi.0fa59815.webp";